import { capNodeAllPorts } from "../cap/index.js";
import { findDefinitionOrFail } from "../mod/index.js";
import { createNet } from "../net/index.js";
import { addNodeFromDefinition } from "../node/addNodeFromDefinition.js";
export function presentNode(mod, nodeName) {
    const net = createNet();
    const definition = findDefinitionOrFail(mod, nodeName);
    const node = addNodeFromDefinition(net, definition);
    capNodeAllPorts(mod, net, node);
    return net;
}
//# sourceMappingURL=presentNode.js.map